import React from 'react';
import { Paperclip } from 'lucide-react';

interface FileAttachmentIndicatorProps {
  count: number;
  className?: string;
}

const FileAttachmentIndicator: React.FC<FileAttachmentIndicatorProps> = ({ count, className = '' }) => {
  return (
    <div className={`file-attachment-indicator ${className}`}>
      <Paperclip size={14} />
      <span>{count}</span>
    </div>
  );
};

export default FileAttachmentIndicator;
